import { UpperAndLowerContext } from './hooks/useUpperAndLowerContext';
import { FormControl } from '@material-ui/core';
import React from 'react';
import useSyncFieldToForm from '../../../pages/hooks/DiffRetainerHooks/useSyncFieldToForm';
import SingleTypePrescriptionNote from './SinglePrescriptionNote';
import PrescriptionBtnGroup from './PrescriptionBtnGroup';
import { RequestRetainerProps } from '../../../pages/DiffRetainer/type';
import FileUploadQuestion from './FileUploadQuestion';
import { useFormContext } from 'react-hook-form';
import useTeethContext from './hooks/useTeethContext';
import SpecialInstruction from './SpecialInstruction';
import useFormQuestionEnable from './hooks/useFormQuestionEnable';
import { useDispatch } from 'react-redux';
import { SET_SPECIAL_INSTRUCTION } from '../../../store/DiffRetainers/actionType';

/**
 * `UpperAndLowerPrescriptionNote` is a component that renders a prescription note for upper and lower teeth.
 *
 * @component
 * @param {RequestRetainerProps} props - The props that define the component.
 */
export const UpperAndLowerPrescriptionNote = (props) => {
    const {
        uiProps,
        oauthProps,
        formProps,
        onError,
        onSubmit,
        questions,
        addOnProps,
        isTab,
        currentEditingType,
        isReSubmit,
    } = props;
    const { errors, formValues, dirtyFields } = formProps;
    const { impressionType, setImpressionType, expanded, setExpanded, handleExpand, isNewCase } = uiProps;
    const { threeshapeConnected, setThreeshapeConnected } = oauthProps;
    const { handleSubmit, control, reset, resetField, setValue, trigger, register } = useFormContext();
    const { upperAndLowerTeethSelections } = useTeethContext();
    const {
        upperToothForBiteRamp,
        setUpperToothForBiteRamp,
        upperToothForPontics,
        setUpperToothForPontics,
        lowerToothForBiteRamp,
        setLowerToothForBiteRamp,
        lowerToothForPontics,
        setLowerToothForPontics,
    } = upperAndLowerTeethSelections;
    const { setSpecialInstruction, specialInstruction, resetAddOnFields } = addOnProps;
    const dispatch = useDispatch();

    const { enableUploadImpression } = useFormQuestionEnable({ formValues, impressionType });
    useSyncFieldToForm(impressionType, setValue, trigger, '', questions[1].name);

    const uiContext = {
        expanded,
        handleExpand,
        impressionType,
    };

    const formContext = {
        control,
        errors,
        formValues,
        dirtyFields,
        resetField,
        setValue,
        trigger,
    };

    return (
        <UpperAndLowerContext.Provider value={{ uiContext, formContext }}>
            <div style={{ width: '100%' }}>
                <FormControl component={'fieldset'} style={{ width: '100%' }}>
                    {/* {hidden input field for inserting value from state} */}
                    <input hidden type="checkbox" {...register('archPosition')} />
                    <SingleTypePrescriptionNote
                        toothForBiteRamp={upperToothForBiteRamp}
                        setToothForBiteRamp={setUpperToothForBiteRamp}
                        toothForPontics={upperToothForPontics}
                        setToothForPontics={setUpperToothForPontics}
                        type={'Upper'}
                        questions={questions}
                        isTab={isTab}
                        currentEditingType={currentEditingType}
                    />
                    <SingleTypePrescriptionNote
                        toothForBiteRamp={lowerToothForBiteRamp}
                        setToothForBiteRamp={setLowerToothForBiteRamp}
                        toothForPontics={lowerToothForPontics}
                        setToothForPontics={setLowerToothForPontics}
                        type={'Lower'}
                        questions={questions}
                        isTab={isTab}
                        currentEditingType={currentEditingType}
                    />
                </FormControl>

                <FileUploadQuestion
                    impressionType={impressionType}
                    question={questions[8]}
                    errors={errors}
                    control={control}
                    enableUploadImpression={enableUploadImpression}
                    threeshapeConnected={threeshapeConnected}
                    setThreeshapeConnected={setThreeshapeConnected}
                    isNewCase={isNewCase}
                    isReSubmit={isReSubmit}
                />

                <SpecialInstruction
                    impressionType={impressionType}
                    value={specialInstruction}
                    onChange={(e) => {
                        setSpecialInstruction(e.target.value);
                        if (isTab) {
                            dispatch({ type: SET_SPECIAL_INSTRUCTION, payload: e.target.value });
                        }
                    }}
                />

                <PrescriptionBtnGroup
                    handleSubmit={handleSubmit}
                    onSubmit={onSubmit}
                    expanded={expanded}
                    setExpanded={setExpanded}
                    impressionType={impressionType}
                    setImpressionType={setImpressionType}
                    reset={reset}
                    formValues={formValues}
                    onError={onError}
                    isNewCase={isNewCase}
                    resetAddOnFields={resetAddOnFields}
                />
            </div>
        </UpperAndLowerContext.Provider>
    );
};
